import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    PICKER_ICON_MOBILE,
    PICKER_ICON_SIZE_MOBILE,
} from '@modules/paint-picker/config';

export const DraggableDot: StyleRule<{
    top: string;
    left: string;
    transform?: string;
    show: boolean;
}> = ({ top, left, transform, show }) => ({
    position: 'absolute',
    top: `calc(${top} - ${pxToRem(PICKER_ICON_SIZE_MOBILE / 2)})`,
    left: `calc(${left} - ${pxToRem(PICKER_ICON_SIZE_MOBILE / 2)})`,
    transform: transform ?? 'none',
    borderRadius: '50%',
    width: pxToRem(PICKER_ICON_SIZE_MOBILE),
    height: pxToRem(PICKER_ICON_SIZE_MOBILE),
    background: PICKER_ICON_MOBILE,
    backgroundSize: pxToRem(PICKER_ICON_SIZE_MOBILE),
    backgroundRepeat: 'no-repeat',
    cursor: 'grab',
    visibility: show ? 'visible' : 'hidden',
});
